import { render, staticRenderFns } from "./ApplicationDetail.vue?vue&type=template&id=79873d2b&"
import script from "./ApplicationDetail.vue?vue&type=script&lang=js&"
export * from "./ApplicationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports